module.exports = __webpack_public_path__ + "img/ina.08b7cb7.png";